import moment from 'moment';
import { mapState } from 'vuex';
import {
  notEmpty,
  maxLength,
  maxLengthPriceNumber,
  maxLengthNumber
} from '@/modules/_global/variables/rules';
import statuses from '../../../common/statuses';
import OrderServiceDetails from '../../OrderServiceDetails';
import OrderCustomerDetails from '../../OrderCustomerDetails';
import {
  REPETITIVE_BUSINESS,
  REPETITIVE_CUSTOMER
} from '@/modules/orders/common/order-types';

export default {
  components: {
    OrderServiceDetails,
    OrderCustomerDetails,
    PlanningBtn: () => import('@/modules/plannings/components/PlanningButton')
  },

  data: () => ({
    valid: true,
    rules: {
      street: [notEmpty, maxLength(100)],
      zip: [notEmpty, maxLength(5)],
      city: [notEmpty, maxLength(40)],
      apartment: [maxLength(40)],
      floor: [maxLength(20)],
      key_deposited: [maxLength(100)],
      service_id: [notEmpty],
      price: [maxLengthPriceNumber(4)],
      duration: [maxLengthNumber(4)],
      description: [maxLength(500)]
    },
    statuses: [],
    services: []
  }),

  computed: {
    ...mapState('order', ['currentOrder']),

    minDateServiceExpected() {
      return this.form.date_entered || moment().format('YYYY-MM-DD');
    },

    selectedService() {
      return (
        this.services.find(service => service.id === this.form.service_id) || {}
      );
    },

    hasInProgressAndOneTime() {
      return (
        this.currentOrder.status_id === statuses.ASSIGNED &&
        Boolean(this.currentOrder.is_tender)
      );
    },

    disabledPlanningButton() {
      const enabledStatuses = [
        statuses.TO_PLAN,
        statuses.IN_PROGRESS,
        statuses.ASSIGNED
      ];

      return (
        this.hasInProgressAndOneTime ||
        !enabledStatuses.includes(this.currentOrder.status_id)
      );
    },

    planningButtonErrorMessages() {
      const errors = [];

      if (this.currentOrder.status_id === statuses.OPEN) {
        errors.push(this.$t('PLANNINGS.PLANNINGS_BUTTON_ERRORS.OPEN'));
      }

      if (this.hasInProgressAndOneTime) {
        errors.push(
          this.$t('PLANNINGS.PLANNINGS_BUTTON_ERRORS.IN_PROGRESS_ONE_TIME')
        );
      }

      return errors;
    }
  },

  methods: {
    setDateServiceExpected(date) {
      this.$refs.menuDateServiceExpected.save(date);
      this.updateValue('date_service_expected', date);
    },
    setService(id) {
      this.setPriceByService(id);
      this.updateValue('service_id', id);
    },
    setPriceByService(id) {
      const service = this.services.find(i => i.id === id);

      if (!service || service.is_on_request) {
        this.form.price = null;
        return;
      }

      this.form.price = service.price;
    },
    countNumber(value) {
      return Math.floor(value).toString().length;
    },
    countNumberPrice(value) {
      return Math.floor(value).toString().length;
    }
  }
};
